import { render, staticRenderFns } from "./RestrictedAreas.vue?vue&type=template&id=b5c2acbc&scoped=true"
import script from "./RestrictedAreas.vue?vue&type=script&lang=js"
export * from "./RestrictedAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c2acbc",
  null
  
)

export default component.exports